<!-- src/components/AcquireZephyrPoints.vue -->
<template>
  <v-app>
    <div class="full-screen-background">
      <!-- Toolbar com título centralizado -->
      <v-toolbar color="transparent" dark class="justify-center">
        <v-toolbar-title class="text-center" style="font-size: 200%;">
          {{ t("zephyr.title") }}
        </v-toolbar-title>
      </v-toolbar>

      <v-main>
        <v-container class="py-4">
          <v-row justify="center">
            <v-col cols="12" sm="8" md="6">
              <!-- Input de valor em reais -->
              <v-text-field
                v-model.number="amountReal"
                :label="t('zephyr.labelAmountReal')"
                type="number"
                min="0"
                step="0.01"
                outlined
              />

              <!-- Exibição do valor convertido enquanto digita -->
              <div class="text-center mt-2">
                {{ t("zephyr.willReceive") }}
                <strong>{{ computedCoins }} {{ t("zephyr.coins") }}</strong>
              </div>

              <!-- Botão de adquirir -->
              <v-btn
                block
                color="#5c3e62"
                dark
                class="mt-4"
                @click="buy"
              >
                {{ t("zephyr.buttonBuy") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </div>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { createPreference } from "@/services/api.js";

const { t } = useI18n();
const amountReal = ref(0);

// 100 Zephyr Coins = 1 R$
const computedCoins = computed(() => Math.round(amountReal.value * 100));

onMounted(() => {
  document.title = t("zephyr.docTitle");
});

async function buy() {
  if (amountReal.value <= 0) {
    return alert(t("zephyr.errorPositive"));
  }
  try {
    const { preferenceId } = await createPreference(amountReal.value);
    window.location.href = `https://www.mercadopago.com.br/checkout/v1/redirect?pref_id=${preferenceId}`;
  } catch (err) {
    console.error("Erro ao iniciar pagamento:", err);
    alert(t("zephyr.errorPayment"));
  }
}
</script>

<style scoped>
.full-screen-background {
  background-image: url("@/assets/background/fundotrocasenha.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
  position: relative;
}
</style>
